export const WebhookV1StandardPayload = class {
    static discriminator = "type";
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadGdsgOperationalArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayload.attributeTypeMap;
    }
    constructor() {
    }
};
export var WebhookV1StandardPayloadTypeEnum;
(function (WebhookV1StandardPayloadTypeEnum) {
    WebhookV1StandardPayloadTypeEnum["BackupJobFailed"] = "BACKUP_JOB_FAILED";
    WebhookV1StandardPayloadTypeEnum["BackupJobSkipped"] = "BACKUP_JOB_SKIPPED";
    WebhookV1StandardPayloadTypeEnum["BackupJobRejected"] = "BACKUP_JOB_REJECTED";
    WebhookV1StandardPayloadTypeEnum["BackupJobSucceeded"] = "BACKUP_JOB_SUCCEEDED";
    WebhookV1StandardPayloadTypeEnum["BackupJobPartial"] = "BACKUP_JOB_PARTIAL";
    WebhookV1StandardPayloadTypeEnum["RestoreJobSucceeded"] = "RESTORE_JOB_SUCCEEDED";
    WebhookV1StandardPayloadTypeEnum["RestoreJobFailed"] = "RESTORE_JOB_FAILED";
    WebhookV1StandardPayloadTypeEnum["RestoreJobRejected"] = "RESTORE_JOB_REJECTED";
    WebhookV1StandardPayloadTypeEnum["ClassificationJobFailed"] = "CLASSIFICATION_JOB_FAILED";
    WebhookV1StandardPayloadTypeEnum["ClassificationJobSkipped"] = "CLASSIFICATION_JOB_SKIPPED";
    WebhookV1StandardPayloadTypeEnum["ClassificationJobRejected"] = "CLASSIFICATION_JOB_REJECTED";
    WebhookV1StandardPayloadTypeEnum["BackupPolicyApplied"] = "BACKUP_POLICY_APPLIED";
    WebhookV1StandardPayloadTypeEnum["BackupPolicyUnapplied"] = "BACKUP_POLICY_UNAPPLIED";
    WebhookV1StandardPayloadTypeEnum["ClassificationPolicyApplied"] = "CLASSIFICATION_POLICY_APPLIED";
    WebhookV1StandardPayloadTypeEnum["ClassificationPolicyUnapplied"] = "CLASSIFICATION_POLICY_UNAPPLIED";
    WebhookV1StandardPayloadTypeEnum["BackupPolicyCreated"] = "BACKUP_POLICY_CREATED";
    WebhookV1StandardPayloadTypeEnum["BackupPolicyUpdated"] = "BACKUP_POLICY_UPDATED";
    WebhookV1StandardPayloadTypeEnum["BackupPolicyDeleted"] = "BACKUP_POLICY_DELETED";
    WebhookV1StandardPayloadTypeEnum["ClassificationPolicyCreated"] = "CLASSIFICATION_POLICY_CREATED";
    WebhookV1StandardPayloadTypeEnum["ClassificationPolicyUpdated"] = "CLASSIFICATION_POLICY_UPDATED";
    WebhookV1StandardPayloadTypeEnum["ClassificationPolicyDeleted"] = "CLASSIFICATION_POLICY_DELETED";
    WebhookV1StandardPayloadTypeEnum["BackupVaultCreated"] = "BACKUP_VAULT_CREATED";
    WebhookV1StandardPayloadTypeEnum["BackupVaultDeleted"] = "BACKUP_VAULT_DELETED";
    WebhookV1StandardPayloadTypeEnum["CloudAccountCreated"] = "CLOUD_ACCOUNT_CREATED";
    WebhookV1StandardPayloadTypeEnum["CloudAccountUpdated"] = "CLOUD_ACCOUNT_UPDATED";
    WebhookV1StandardPayloadTypeEnum["CloudAccountDeleted"] = "CLOUD_ACCOUNT_DELETED";
    WebhookV1StandardPayloadTypeEnum["CloudAccountDeactivated"] = "CLOUD_ACCOUNT_DEACTIVATED";
    WebhookV1StandardPayloadTypeEnum["CloudAccountActivated"] = "CLOUD_ACCOUNT_ACTIVATED";
    WebhookV1StandardPayloadTypeEnum["CloudAccountAccessLost"] = "CLOUD_ACCOUNT_ACCESS_LOST";
    WebhookV1StandardPayloadTypeEnum["RansomwareDetectedInResource"] = "RANSOMWARE_DETECTED_IN_RESOURCE";
    WebhookV1StandardPayloadTypeEnum["RansomwareInfectionRemediated"] = "RANSOMWARE_INFECTION_REMEDIATED";
    WebhookV1StandardPayloadTypeEnum["ResourceExcludedFromRansomwareDetection"] = "RESOURCE_EXCLUDED_FROM_RANSOMWARE_DETECTION";
    WebhookV1StandardPayloadTypeEnum["RansomwareDetectionExclusionCanceled"] = "RANSOMWARE_DETECTION_EXCLUSION_CANCELED";
    WebhookV1StandardPayloadTypeEnum["MalwareRemediated"] = "MALWARE_REMEDIATED";
    WebhookV1StandardPayloadTypeEnum["DataAnomalyRemediated"] = "DATA_ANOMALY_REMEDIATED";
    WebhookV1StandardPayloadTypeEnum["AiDataRiskRemediated"] = "AI_DATA_RISK_REMEDIATED";
    WebhookV1StandardPayloadTypeEnum["DataExposureRiskRemediated"] = "DATA_EXPOSURE_RISK_REMEDIATED";
    WebhookV1StandardPayloadTypeEnum["RansomwareDetectedInSnapshot"] = "RANSOMWARE_DETECTED_IN_SNAPSHOT";
    WebhookV1StandardPayloadTypeEnum["MalwareDetectedInSnapshot"] = "MALWARE_DETECTED_IN_SNAPSHOT";
    WebhookV1StandardPayloadTypeEnum["DataAnomalyDetectedInSnapshot"] = "DATA_ANOMALY_DETECTED_IN_SNAPSHOT";
    WebhookV1StandardPayloadTypeEnum["AiDataRiskDetectedInSnapshot"] = "AI_DATA_RISK_DETECTED_IN_SNAPSHOT";
    WebhookV1StandardPayloadTypeEnum["DataExposureRiskDetectedInSnapshot"] = "DATA_EXPOSURE_RISK_DETECTED_IN_SNAPSHOT";
    WebhookV1StandardPayloadTypeEnum["SnapshotUserProtected"] = "SNAPSHOT_USER_PROTECTED";
    WebhookV1StandardPayloadTypeEnum["SnapshotUserUnprotected"] = "SNAPSHOT_USER_UNPROTECTED";
    WebhookV1StandardPayloadTypeEnum["SnapshotIncludesAccessDeniedItems"] = "SNAPSHOT_INCLUDES_ACCESS_DENIED_ITEMS";
    WebhookV1StandardPayloadTypeEnum["HighSeverityViolationsDetectedOnResources"] = "HIGH_SEVERITY_VIOLATIONS_DETECTED_ON_RESOURCES";
    WebhookV1StandardPayloadTypeEnum["MediumSeverityViolationsDetectedOnResources"] = "MEDIUM_SEVERITY_VIOLATIONS_DETECTED_ON_RESOURCES";
    WebhookV1StandardPayloadTypeEnum["LowSeverityViolationsDetectedOnResources"] = "LOW_SEVERITY_VIOLATIONS_DETECTED_ON_RESOURCES";
    WebhookV1StandardPayloadTypeEnum["ViolationsResolvedOnResources"] = "VIOLATIONS_RESOLVED_ON_RESOURCES";
    WebhookV1StandardPayloadTypeEnum["IssueMutedOnResource"] = "ISSUE_MUTED_ON_RESOURCE";
    WebhookV1StandardPayloadTypeEnum["IssueUnmutedOnResource"] = "ISSUE_UNMUTED_ON_RESOURCE";
    WebhookV1StandardPayloadTypeEnum["JobMetricsReportFailed"] = "JOB_METRICS_REPORT_FAILED";
    WebhookV1StandardPayloadTypeEnum["NotificationTargetCreated"] = "NOTIFICATION_TARGET_CREATED";
    WebhookV1StandardPayloadTypeEnum["NotificationTargetUpdated"] = "NOTIFICATION_TARGET_UPDATED";
    WebhookV1StandardPayloadTypeEnum["NotificationTargetDeleted"] = "NOTIFICATION_TARGET_DELETED";
    WebhookV1StandardPayloadTypeEnum["NotificationTargetEnabled"] = "NOTIFICATION_TARGET_ENABLED";
    WebhookV1StandardPayloadTypeEnum["NotificationTargetDisabled"] = "NOTIFICATION_TARGET_DISABLED";
    WebhookV1StandardPayloadTypeEnum["CreditsUsageThreshold75"] = "CREDITS_USAGE_THRESHOLD_75";
    WebhookV1StandardPayloadTypeEnum["CreditsUsageThreshold90"] = "CREDITS_USAGE_THRESHOLD_90";
    WebhookV1StandardPayloadTypeEnum["CreditsUsageThreshold95"] = "CREDITS_USAGE_THRESHOLD_95";
    WebhookV1StandardPayloadTypeEnum["CreditsMonthlyUsage80"] = "CREDITS_MONTHLY_USAGE_80";
    WebhookV1StandardPayloadTypeEnum["CreditsMonthlyUsage90"] = "CREDITS_MONTHLY_USAGE_90";
    WebhookV1StandardPayloadTypeEnum["CreditsMonthlyUsage100"] = "CREDITS_MONTHLY_USAGE_100";
    WebhookV1StandardPayloadTypeEnum["MpaRequestPendingApproval"] = "MPA_REQUEST_PENDING_APPROVAL";
    WebhookV1StandardPayloadTypeEnum["MpaRequestExecuted"] = "MPA_REQUEST_EXECUTED";
    WebhookV1StandardPayloadTypeEnum["MpaRequestExpired"] = "MPA_REQUEST_EXPIRED";
    WebhookV1StandardPayloadTypeEnum["MpaRequestCancelled"] = "MPA_REQUEST_CANCELLED";
    WebhookV1StandardPayloadTypeEnum["MpaRequestApproved"] = "MPA_REQUEST_APPROVED";
    WebhookV1StandardPayloadTypeEnum["MpaRequestDenied"] = "MPA_REQUEST_DENIED";
    WebhookV1StandardPayloadTypeEnum["MpaRequestPartiallyApproved"] = "MPA_REQUEST_PARTIALLY_APPROVED";
    WebhookV1StandardPayloadTypeEnum["GdsgSlaBreached"] = "GDSG_SLA_BREACHED";
    WebhookV1StandardPayloadTypeEnum["GdsgSystemInaccessible"] = "GDSG_SYSTEM_INACCESSIBLE";
    WebhookV1StandardPayloadTypeEnum["GdsgWorkerFailure"] = "GDSG_WORKER_FAILURE";
})(WebhookV1StandardPayloadTypeEnum || (WebhookV1StandardPayloadTypeEnum = {}));
